<template>
  <router-view />
</template>

<script>
export default {
  name: 'Leads',
}
</script>
